module.exports = __webpack_public_path__ + "static/img/phone_ico_logo.74fcabe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultural_products/phone_ico_logo.png
// module id = CxnZ
// module chunks = 0